module.exports = __webpack_public_path__ + "static/media/modelagem_processo.34cddcfb.png";